export const PREVIEW_PROTOCOL_VERSION = 2

export const PreviewMessage = Object.freeze({
  INIT: 'studio-editor-v2:init',
  UPDATE: 'studio-editor-v2:config-update',
  PATCH: 'studio-editor-v2:config-patch',
  SELECT_SLIDE: 'studio-editor-v2:select-slide',
  SELECT_COLLECTION_ITEM: 'studio-editor-v2:select-collection-item',
  RESTART: 'studio-editor-v2:restart',
  READY: 'studio-editor-v2:ready',
  RENDERED: 'studio-editor-v2:rendered',
  PATCHED: 'studio-editor-v2:patched',
  SLIDE_SELECTED: 'studio-editor-v2:slide-selected',
  COLLECTION_ITEM_SELECTED: 'studio-editor-v2:collection-item-selected',
  LAYOUT_DIAGNOSTICS: 'studio-editor-v2:layout-diagnostics',
  ERROR: 'studio-editor-v2:error',
})
